import EFPicture from '@elem/compCommon/EFPicture';
import css from './Modal.module.scss';

export default function Modal({ callback }: any) {
    const bills = [
        {
            img: '/responsive/picture/delta-pro-ultra-daily-use/4_1.jpg',
            text: '2023.March',
        },
        {
            img: '/responsive/picture/delta-pro-ultra-daily-use/4_2.jpg',
            text: '2024.March',
        },
    ];
    return (
        <div className={`modal ${css.modal}`}>
            <div className="modal-content">
                <div className="close-icon">
                    <svg className="close" onClick={callback} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <p className="title">{"Here's a comparison of March 2024 to March 2023."}</p>
                <ul className="bills">
                    {bills?.map((bill: any, k: number) => (
                        <li className="bill" key={k}>
                            <div className="bill-img">
                                <EFPicture src={bill.img} alt={bill.text} />
                            </div>
                            <p className="bill-text">{bill.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
            {/* <style jsx global>
                {`
                    .page-layout {
                        height: 100vh;
                        overflow: hidden;
                    }
                `}
            </style> */}
        </div>
    );
}
